// This file addresses compatibility issues encountered with third-party integrations.
// It is part of the main build process but is not included in the main bundle.

// This snippet addresses compatibility issues with Algolia's Shopify plugin.
// for more context please look at https://onetextworkspace.slack.com/archives/C04PHGZNPB6/p1734643653527089

document.addEventListener('algolia.hooks.initialize', () => {
    if (window.algoliaShopify) {
        window.algoliaShopify.hooks.registerHook('beforeInstantSearchAllowParamsArray', () => {

            // Get all existing URL parameters
            const urlParams = new URLSearchParams(window.location.search);
            const existingParams = Array.from(urlParams.keys());

            // Use only the existing URL parameters
            return existingParams;
        });
    }
});
